const initialState = {}
const indicatorsReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'SET_INDICATORS_DATA':
    return {
      ...state,
      indicatorsData: action.indicatorsData
    }
  case 'SET_INDICATORS_LAST_UPDATED':
    return {
      ...state,
      lastUpdated: action.lastUpdated
    }
  default:
    return state
  }
}

export default indicatorsReducer



// WEBPACK FOOTER //
// ./src/redux/Reducers/indicatorsReducer.js